import {
  CLEAR_AUTH_DATA,
  LOAD_AUTH_DATA,
  SET_AUTH_TOKEN,
  SET_KEYCLOAK_INSTANCE,
  SET_LOADING,
  SET_RECENT_API_CALLS,
  SET_REFRESH,
  SET_REMAINING_TIME,
} from './actionTypes';

const initialState = {
  user: null,
  isAuthenticated: false,
  isLoading: true,
  keycloak: null,
  authPolicies: [{ allowed: [], denied: [], operation: '', resourceGroup: '' }],
  authToken: null,
  recentAPICalls: [],
  remainingTime: null,
  refresh: false,
  isConfigUser: false,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_AUTH_DATA:
      return initialState;
    case SET_KEYCLOAK_INSTANCE:
      return { ...state, keycloak: action.instance };
    case SET_AUTH_TOKEN:
      return { ...state, authToken: action.token };
    case LOAD_AUTH_DATA:
      return { ...state, ...action.payload };
    case SET_RECENT_API_CALLS:
      return { ...state, recentAPICalls: action.payload };
    case SET_REMAINING_TIME:
      return { ...state, remainingTime: action.payload };
    case SET_REFRESH:
      return { ...state, refresh: action.payload };
    case SET_LOADING:
      return { ...state, isLoading: action.loading };
    default:
      return state;
  }
}
